import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { connect } from "react-redux";
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
// material
import {
    Link,
    Card,
    Stack,
    Checkbox,
    TextField,
    IconButton,
    InputAdornment,
    FormControlLabel,
    Container,
    Typography,
    TableContainer,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    Grid
} from '@mui/material';
import { ListHead, ListToolbar, MoreMenu } from '../../components/_dashboard/car';
import { LoadingButton } from '@mui/lab';
import Scrollbar from '../../components/Scrollbar';
import { fetchAllReProcessings, printReProcessing } from '../../actions/reProcessingAction';
import _ from 'lodash';
import Page from '../../components/Page';
import { styled } from '@mui/material/styles';
import CloudDownload from "@material-ui/icons/CloudDownload";
import Edit from "@material-ui/icons/Edit";
import DeleteOutlined from "@material-ui/icons/DeleteOutlined";
import ModalCompoennt from '../Portal/ModalCompoennt';
import DeleteReProcessing from './DeleteReProcessing';
import Pagination from '@mui/material/Pagination';


// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
    maxWidth: 680,
    margin: 'auto',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
}));

const TABLE_HEAD = [
    { id: 'id', label: 'ID', alignRight: false },
    { id: 'car_name', label: 'Car Name', alignRight: false },
    { id: 'buyer_name', label: 'Buyer Name', alignRight: false },
    { id: 'chasis_no', label: 'Chasis No', alignRight: false },
    { id: 'auctioneer_name', label: 'Auctioneer Name', alignRight: false },
    { id: 'po_box', label: 'Auctioneer Po Box', alignRight: false },
    { id: 'actions', label: 'Action', alignRight: false },

];

function ReProcessingList(props) {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [adminObj, setAdminObj] = useState({});
    const [openUpdate, setOpenUpdate] = useState(false);
    const [addOpen, setAddOpen] = useState(false);
    const [updateOpen, setUpdateOpen] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [processingObj, setProcessingObj] = useState({});

    useEffect(() => {
        setIsLoading(false);
    }, [props.alerts]);

    useEffect(() => {
        props.fetchAllReProcessings(page);
    }, []);

    const handleUpdateClick = (a) => {
        setOpenUpdate(true);
        setProcessingObj(a);
    }

    const handleAddClick = () => {
        setAddOpen(true);
    }
    
    const closeButton = () => {
        setOpenUpdate(false);
        setAddOpen(false);
        setOpenDelete(false);
        setProcessingObj({});
    }

    const handleDownloadClick = (r) => {
        const values = {};
        values.re_processing_id = r.id;
        values.car_detail_id = r.car.id;
        return props.printReProcessing(values);
    }

    const hanldeDeleteClick = (r) => {
        setOpenDelete(true);
        setProcessingObj(r);
    }

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
        props.fetchAllReProcessings(newPage)
    }

    const renderReProcessingsList = () => {
        if(!_.isEmpty(props.reprocessings.data)) {
            var reprocessings = props.reprocessings.data;
            var f_reprocessings = _.orderBy(reprocessings, ['id'], ['desc']);
            return f_reprocessings.map((r) => {
                return (
                    <TableRow
                        hover
                        tabIndex={-1}
                    >
                        <TableCell align="left" style={{padding:"10px"}}>{r.id}</TableCell>
                        <TableCell align="left" style={{padding:"10px"}}>{r.car.motor}</TableCell>
                        <TableCell align="left" style={{padding:"10px"}}>{r.car.buyer_name}</TableCell>
                        <TableCell alig n="left" style={{padding:"10px"}}>{r.car.chasis_no}</TableCell>
                        <TableCell align="left" style={{padding:"10px"}}>{r.auctioneer_name}</TableCell>
                        <TableCell align="left" style={{padding:"10px"}}>{r.po_box}</TableCell>
                        <TableCell colSpan={3}>
                        <IconButton sx={{float:"left",padding:"0px", color:"#c29136"}} onClick={() => handleDownloadClick(r)}>
                            <CloudDownload />
                        </IconButton>
                        <IconButton sx={{float:"left",padding:"0px", color:"red"}} onClick={() => hanldeDeleteClick(r)}>
                            <DeleteOutlined />
                        </IconButton>
                        </TableCell>
                    </TableRow>
                );
            })
        } else {
            return <TableRow>
                <TableCell colSpan={7}>No Record Exist</TableCell>
            </TableRow>
        }
    }

    return (
        <Page title="Re Processing List">
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                <Grid>
                    <Typography variant="h4" gutterBottom>
                        Re Processing List 
                    </Typography>
                </Grid>
            </Stack>
            <Card>
                <Scrollbar>
                    <TableContainer sx={{ minWidth: 800 }}>
                        <Table>
                            <ListHead
                                headLabel={TABLE_HEAD}
                                rowCount={props.reprocessings.length}
                            />
                            <TableBody>
                                {renderReProcessingsList()}
                            </TableBody>
                        </Table>
                        <Pagination sx={{float:"right",marginTop:"10px",marginBottom:"10px"}} page={page} count={props.reprocessings.paginate.last_page} variant="outlined" color="primary" onChange={handlePageChange} />
                    </TableContainer>
                </Scrollbar>
            </Card>
            {
                openDelete &&
                <ModalCompoennt open={openDelete} onClose={closeButton} title="Delete" width="xs" color="red">
                    <DeleteReProcessing reprocessing={processingObj} onDismis={closeButton} />
                </ModalCompoennt>
            }
        </Page>
    );
}
const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        alerts: state.alerts,
        reprocessings: state.reProcessing,
    }
}

export default connect(mapStateToProps, { fetchAllReProcessings, printReProcessing })(ReProcessingList);

